import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { selectPagination } from "../../modules/Auth/_redux/authRedux";
import {
  fetchReasonCode,
  setPermissionMasterUpload,
  setPermissionReasonCode,
} from "./MiscellaneousSlice";
import { ReasonCodeTab } from "./ReasonCodeTab";
import { MasterUploadTab } from "./MasterUploadTab";
import { fetchMenuTab, selectMenuTab, selectLoading } from "../menu/menuSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { checkMenu } from "../../utility";

export const MiscellaneousPage = () => {
  const dispatch = useDispatch();
  const [active, setActive] = useState("");
  const paginationSet = useSelector(selectPagination);
  const [list, setList] = useState(null);
  const dataMenuTab = useSelector(selectMenuTab);
  const loading = useSelector(selectLoading);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchMenuTab({
          menu_url: "/master/miscellaneous",
        })
      );
      await dispatch(
        fetchReasonCode({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      setActive(data[0]);

      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Reason Code Master") {
          return dispatch(setPermissionReasonCode(item.permissions));
        }
        if (item.menu_name === "Master Upload") {
          return dispatch(setPermissionMasterUpload(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {list && (
        <div>
          <Tabs
            defaultActiveKey="Reason Code Master"
            id="uncontrolled-tab-example"
            onSelect={(e) => setActive(e)}
          >
            {checkMenu(list, "Reason Code Master") && (
              <Tab eventKey="Reason Code Master" title="Reason Code Master">
                <ReasonCodeTab />
              </Tab>
            )}
            {checkMenu(list, "Master Upload") && (
              <Tab eventKey="Master Upload" title="Master Upload">
                <MasterUploadTab />
              </Tab>
            )}
          </Tabs>
        </div>
      )}
    </>
  );
};
